import { render, staticRenderFns } from "./OrganizationStatisticDetail.vue?vue&type=template&id=7f29860c&"
import script from "./OrganizationStatisticDetail.vue?vue&type=script&lang=js&"
export * from "./OrganizationStatisticDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports